import { UserState } from 'src/models/user';

const initialState: UserState = {
  token: undefined,
};

export default initialState;
